import { BaseService } from '../base';

export type BenefitType = {
  /** Código da modalidade (gravado em `BenefitTypeCode` no PolicyRiskGroup). */
  code: number;
  /** Descrição exibida no front (ex.: "Uniforme", "Variável"). */
  description: string;
  individualLimit?: number;
};

export type BenefitTypesResponse = BenefitType[];

/** Modalidades do PME — DataTable `BenefitType` do InsureMO (proxy do Portal). */
export class BenefitTypesService extends BaseService {
  async list(): Promise<{
    success: boolean;
    data?: BenefitTypesResponse;
    error?: string;
  }> {
    try {
      const response = await this.get(
        '/portal/v1/services/benefit-types',
        {},
        import.meta.env.VITE_API_URL,
      );
      return await this.handleJsonResponse<BenefitTypesResponse>(response);
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error
            ? error.message
            : 'Erro ao carregar tipos de benefício',
      };
    }
  }
}

export const benefitTypesService = new BenefitTypesService();
